import { ChannelType, ClientType } from '@features/termination/enums';

export interface PersonalInformation {
  email: string;
  fullName: string;
  firstName: string;
  gender: number;
  dateOfBirth: string;
  identification: string;
  applicantLastName: string;
  applicantFirstName: string;
  countryOfBirth: string;
  communeOfBirth: string;
  channelType: string;
  address: string;
  postalCode: string;
  city: string;
}

export const initialPersonalInformation = {
  email: '',
  fullName: '',
  firstName: '',
  gender: 0,
  dateOfBirth: '',
  identification: ClientType.PHYSICAL_PERSON,
  applicantLastName: '',
  applicantFirstName: '',
  countryOfBirth: '',
  communeOfBirth: '',
  channelType: ChannelType.EMAIL,
  address: '',
  postalCode: '',
  city: '',
};
